import { BaseEntity } from '../models/base-entity';
import {
  signalStoreFeature,
  type,
  withComputed,
  withMethods,
} from '@ngrx/signals';
import { BaseState } from './crud.state';
import { computed } from '@angular/core';

export function withWorkspaceHelpers<Entity extends BaseEntity>() {
  return signalStoreFeature(
    {
      state: type<BaseState<Entity>>(),
    },
    withComputed(store => ({
      workspaceIds: computed(() => {
        const items: Entity[] = Object.values(store.items());
        return [
          ...new Set(items.flatMap((item: Entity) => item['workspaces'])),
        ];
      }),
    })),
    withMethods(store => ({
      filterByWorkspace(workspaceId: string) {
        return Object.values(store.items())
          .filter(item => {
            return (
              item['workspaces'] && item['workspaces'].includes(workspaceId)
            );
          })
          .map((item: Entity) => item._id) as string[];
      },
    }))
  );
}
